import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '../utils/text';
import api from '../utils/api';
import { MediaItemShape } from '../utils/shapes';
import AttachmentPreviewList from './AttachmentPreviewList';
import UploadBox from './UploadBox';

class Attachments extends React.Component {
    static propTypes = {
        accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        name: PropTypes.string.isRequired,
        initialMediaItems: PropTypes.arrayOf(MediaItemShape),
    };

    static defaultProps = {
        accept: undefined,
        initialMediaItems: undefined,
    };

    constructor(props) {
        super(props);
        const initialState = {
            files: {},
            mediaItems: [],
            filesBeingUploaded: 0,
            errorMessage: null,
        };
        if (props.initialMediaItems) {
            initialState.mediaItems = props.initialMediaItems;
        }
        this.state = initialState;
    }

    componentWillUnmount() {
        // Revoke all previews to avoid memory leaks
        this.state.files.forEach((file) => window.URL.revokeObjectURL(file.preview));
    }

    onDrop(acceptedFiles, rejectedFiles) {
        if (this.state.mediaItems.length + acceptedFiles.length > 20) {
            this.setState({
                errorMessage: gettext("You can't upload more than 20 attachments."),
            });
            return;
        }
        if (acceptedFiles.length > 0) {
            acceptedFiles.forEach((file) => this.uploadFile(file));
        }
        if (rejectedFiles.length > 0) {
            this.setState({
                errorMessage: gettext('Some of the file(s) you uploaded were rejected because of their type'),
            });
        }
    }

    uploadFile(file) {
        this.setState((currentState) => ({
            filesBeingUploaded: currentState.filesBeingUploaded + 1,
        }));
        const attachment = {
            field: 'files',
            file,
            name: file.name,
        };
        api.mediaUploadPrivate
            .post(null, null, null, [attachment])
            .then((result) => {
                const response = typeof result === 'string' ? JSON.parse(result) : result;
                if (response.success) {
                    const mediaItem = response.uploads[0];
                    this.setState((currentState) => ({
                        mediaItems: [mediaItem, ...currentState.mediaItems],
                        files: {
                            ...currentState.files,
                            [mediaItem.id]: file,
                        },
                    }));
                } else {
                    const name = file.name;
                    const reason = result.error ? result.error : '';
                    this.setState({
                        errorMessage: gettext(`File upload failed for file ${name}. ${reason}`),
                    });
                }
            })
            .finally(() => {
                this.setState((currentState) => ({
                    filesBeingUploaded: currentState.filesBeingUploaded - 1,
                }));
            });
    }

    deleteMedia(mediaId) {
        api.mediaDelete.post({ pk: mediaId }).then((result) => {
            const newMediaItems = [...this.state.mediaItems];
            const removeIndex = newMediaItems.findIndex((mediaItem) => mediaItem.id === mediaId);
            if (removeIndex !== -1) {
                newMediaItems.splice(removeIndex, 1);
                this.setState({ mediaItems: newMediaItems });
            }
        });
    }

    render() {
        return (
            <div className="attachments">
                <UploadBox
                    accept={this.props.accept}
                    filesAreBeingUploaded={this.state.filesBeingUploaded > 0}
                    onDrop={(...args) => this.onDrop(...args)}
                />
                <div className="subtitle mt-4 mb-4">
                    {gettext(
                        'Trafo.no supports most common file formats. The files you upload here will only be available in ' +
                            'the application and will not be published publicly on Trafo.no.',
                    )}
                </div>
                {this.state.errorMessage && <div className="alert alert-danger">{this.state.errorMessage}</div>}
                <AttachmentPreviewList
                    mediaItems={this.state.mediaItems}
                    files={this.state.files}
                    onDelete={(mediaId) => this.deleteMedia(mediaId)}
                />
                <select
                    name={this.props.name}
                    value={this.state.mediaItems.map((mediaItem) => mediaItem.id)}
                    multiple
                    hidden
                    readOnly
                >
                    {this.state.mediaItems.map((mediaItem) => (
                        <option key={mediaItem.id} value={mediaItem.id} />
                    ))}
                </select>
            </div>
        );
    }
}

export default Attachments;



// WEBPACK FOOTER //
// ./src/components/Attachments.js